import { Get, Patch, Post, Delete } from 'utils/axios';


/** 
 * @desc 获取章节目录
 * @param {object} param 
 */
export function reqGetChapter(params) {
  let url = `/api/v1/classroom/chapter`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * 更新用户选择学科学段版本等信息
**/
export function reqUpdateUserSelected(params) {
  let url = '/api/v1/classroom/chapter';
  return Patch(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
 
}

/** 
 * @desc 获取同步课程
 * @param {object} param 
 */
export function reqGetResourceList(params) {
  let url = '/api/v1/classroom/resources';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

